// https://gist.github.com/mcshaz/c65040c11e6daffe356cbedb7ec84ce4
if (!HTMLFormElement.prototype.requestSubmit) {
  HTMLFormElement.prototype.requestSubmit = function() {
    const submitBtn = document.createElement('input');
    submitBtn.type = 'submit';
    submitBtn.hidden = true;
    this.appendChild(submitBtn);
    submitBtn.click();
    this.removeChild(submitBtn);
  };
}

if (!HTMLFormElement.prototype.reportValidity) {
  HTMLFormElement.prototype.reportValidity = function() {
    if (this.checkValidity()){
      return true;
    }
    if (this.noValidate){
      this.noValidate = false;
      this.requestSubmit();
      this.noValidate = true;
    } else {
      this.requestSubmit();
    }
    return false;
  };
}